const navigationPathMapper = {
  texas_tax_roll_files: new RegExp("texas-tax-roll-files"),
  permit_plats: new RegExp("permit-plats"),
  permits: new RegExp("permits"),
  units: new RegExp("/units"),
  owners: new RegExp("owners"),
  owner_name_addresses: new RegExp("owner-name-addresses"),
  field_units: new RegExp("field-units"),
  // interests: new RegExp("interests"),
  offers: new RegExp("offers"),
  leads: new RegExp("leads"),
  deal_reviews: new RegExp("deal-reviews"),
  titles: new RegExp("^/titles"),
  evaluations: new RegExp("evaluations"),
  paperworks: new RegExp("paperworks"),
  activities: new RegExp("^/activities"),
  mail_exports: new RegExp("mail-exports"),
  mail_queue: new RegExp("/mail-queue"),
  usps_bulk_searches: new RegExp("usps-bulk-searches"),
  usps_addresses: new RegExp("usps-addresses"),
  usps_searches: new RegExp("usps-searches"),
  idi_bulk_searches: new RegExp("idi-bulk-searches"),
  pipedrive_uploads: new RegExp("pipedrive-uploads"),
  whitepages_bulk_searches: new RegExp("whitepages-bulk-searches"),
  acquisitionsReportsMain: new RegExp("acquisitions/reports/main"),
  mailerChecks: new RegExp("acquisitions/mailer-checks"),
  area_of_interests: new RegExp("area-of-interests"),
  endato_searches: new RegExp("endato-searches"),
  endato_persons: new RegExp("endato-persons"),
  whitepages_searches: new RegExp("whitepages-searches"),
  whitepages_persons: new RegExp("whitepages-persons"),
  idi_searches: new RegExp("idi-searches"),
  idi_persons: new RegExp("idi-persons"),
  alerts: new RegExp("management/alerts"),
  calls: new RegExp("^/calls"),
  conversations: new RegExp("^/conversations"),
  caller_id_reputations: new RegExp("caller-id-reputations"),
  phone_validation: new RegExp("^/phones$"),
  map: new RegExp("map"),
  entities: new RegExp("management/entities"),
  assets: new RegExp("management/assets"),
  tracts: new RegExp("management/tracts"),
  deals: new RegExp("management/deals"),
  tickets: new RegExp("management/tickets"),
  wells: new RegExp("management/wells"),
  operator_payors: new RegExp("management/operator-payors"),
  operators: new RegExp("management/operators"),
  royalties: new RegExp("management/royalties"),
  taxing_entities: new RegExp("management/taxing-entities"),
  tax_statements: new RegExp("management/tax-statements"),
  tax_appraisals: new RegExp("management/tax-appraisals"),
  sales: new RegExp("management/sales"),
  profile: new RegExp("settings/users/"),
  users: new RegExp("settings/users$"),
  interest_filters: new RegExp("settings/interest-filters"),
  lead_customization: new RegExp("settings/lead-customization"),
  pipedrive_syncs: new RegExp("settings/pipedrive-syncs"),
  enverus_syncs: new RegExp("settings/enverus-syncs"),
  rrc_syncs: new RegExp("settings/rrc-syncs"),
  sonris_syncs: new RegExp("settings/sonris-syncs"),
  owner_syncs: new RegExp("settings/owner-syncs"),
  jobs: new RegExp("settings/jobs"),
  mail_templates: new RegExp("settings/mail-templates"),
  acquisitions_settings: new RegExp("settings/acquisitions"),
  labels: new RegExp("settings/labels"),
};

const getNavSelectedKeys = (pathname) => {
  for (const [key, value] of Object.entries(navigationPathMapper)) {
    if (value.test(pathname)) {
      return [key];
    }
  }
};

export { getNavSelectedKeys };
